<template>
  <div class="feceTips">
    <div class="navBar-wrap">
      <div class="navBar" :style="{ backgroundColor: '#EDEDED'  }">
        <div class="arrowLeft"  @click="goback"><img :src="arrowLeft" alt="" /></div>
        <p class="title">{{ '人脸照片注意事项' }}</p>
        <div  class="submit-none"></div>
      </div>
    </div>
    <div class="content">
      <img src="../../../assets/images/faceTipsBG.png"  style="width: 100%; height: 100%; object-fit: cover;"/>
    </div>
  </div>
</template>
<script>
import NavBar from '@/components/newNavBar'
import arrowLeft from '@/assets/images/arrow-left.svg'
export default {
  name: 'SendInvitation',
  components: {
    NavBar,
  },
  data() {
    return {
      sourceIsH5: true,
      arrowLeft
    }
  },
  methods: {
    goback(){
      this.$router.back()
    }
  },
  created() {
  },
  mounted() {
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
  },
}
</script>
<style lang="less" scoped>
.feceTips {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  .navBar-wrap {
    height: 44px;
    width: 100%;
    background-color: #ffffff;
  }
  .content {
    width: 375px;
    height: 680px;
    box-sizing: border-box;

  }
  .navBar {
    height: 44px;
    width: 100%;
    display: flex;
    position: relative;
    padding: 10px 16px;
    justify-content: space-between;
    align-items: center;
    .arrowLeft{
      width: 24px;
      height: 24px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .title {
      font-size: 18px;
      font-weight: 500;
      color: #1e2329;
      line-height: 24px;
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-style: normal;
    }
    .submit-none {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
